module.exports = __webpack_public_path__ + "static/media/ico-picker.822aa0d0.svg";